import baseSetToString from './_baseSetToString.js';
import shortOut from './_shortOut.js';

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

export default setToString;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/_setToString.js
// module id = 1489
// module chunks = 1